import { ThemeDayNightSwitch } from './ThemeDayNightSwitch';

/** Sun/moon animated switch — replaces light/dark/system icon buttons. */
export function ThemeToggle({ useMalayalam = false, compact: _compact = false }) {
  return <ThemeDayNightSwitch useMalayalam={useMalayalam} />;
}
